interface ScrapingStatusProps {
  isLoading: boolean;
  error: string | null;
  pageCount?: number;
}

export function ScrapingStatus({ isLoading, error, pageCount }: ScrapingStatusProps) {
  if (error) {
    return (
      <div className="card p-4 border-rose-500/30 animate-slide-up">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-rose-500/20 flex items-center justify-center flex-shrink-0">
            <svg className="w-5 h-5 text-rose-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-medium text-rose-400">Transformation failed</p>
            <p className="text-sm text-rose-300/80 mt-0.5 break-words">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="card p-4 border-primary-500/30 animate-slide-up overflow-hidden relative">
        <div className="absolute inset-0 shimmer" />

        <div className="relative flex items-center gap-4">
          <div className="relative w-10 h-10">
            <div className="absolute inset-0 rounded-lg border-2 border-primary-500/30 border-t-primary-500 animate-spin" />
          </div>

          <div className="flex-1">
            <p className="font-medium text-primary-300">Transforming content...</p>
            <p className="text-sm text-surface-400 mt-0.5">Extracting and converting to markdown...</p>
          </div>
        </div>
      </div>
    );
  }

  if (pageCount && pageCount > 0) {
    return (
      <div className="card p-4 border-emerald-500/30 animate-slide-up">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-emerald-500/20 flex items-center justify-center flex-shrink-0">
            <svg className="w-5 h-5 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <div className="flex-1">
            <p className="font-medium text-emerald-400">Transformation complete</p>
            <p className="text-sm text-surface-400 mt-0.5">
              Successfully extracted {pageCount} {pageCount === 1 ? 'page' : 'pages'}
            </p>
          </div>

          <div className="px-3 py-1.5 bg-emerald-500/20 rounded-md border border-emerald-500/30">
            <span className="text-lg font-bold text-emerald-400">{pageCount}</span>
            <span className="text-sm text-emerald-500 ml-1">{pageCount === 1 ? 'page' : 'pages'}</span>
          </div>
        </div>
      </div>
    );
  }

  return null;
}
